/*
 * Usage:
 * syntax: <input oly-autotab="target" tab-when="<expression>" />
 * target: value of the name attribute of the input to be tabbed to (required as getting the 'next' element is complicated)
 * tab-when: an expression which will return true when tabbing should occur (evaluated when the user releases a key)
 *
 * example: The following will tab to an input named 'month' when the length of the entered text is 2
 *          <input type="text" id="Day" ng-model="day" oly-autotab="month" tab-when="'Day.length === 2'"/>
 */
module.exports = function () {
    return {
        restrict: 'A',
        scope: {
            target: '@olyAutotab',
            tabWhen: '&'
        },
        link(scope, element) {
            element.on('keyup', function (event) {
                const key = event.which || event.keyCode;
                // Ignore the shift and tab keys for accessibility
                if (key === 9 || key === 16) {
                    return;
                }
                const elem = document.getElementById(scope.target);
                if (elem && scope.tabWhen()) {
                    elem.focus();
                }
            });
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/autotab/autotab-directive.js
 **/